import { StringHelper } from "../../../../../../helper";
import { AFLType } from "../../models";

export const form24 = (record: any) => {
  return {
    departmentCode: "1",
    aflType: AFLType.SickLeaveApplication,
    layout: [
      {
        type: "header",
        value: {
          form: 1,
          department: StringHelper.verticalBarSplit(record?.eDepartment)[1],
        },
      },
      {
        type: "title",
        value: {
          sub: [],
        },
      },
      {
        type: "salutation",
        value: [
          "Tổng Giám đốc",
          `Trưởng phòng ${StringHelper.verticalBarSplit(record?.eUnit)[1]};`,
          "Trưởng phòng Tổ chức và Nhân lực.",
        ],
      },
      {
        type: "content",
        value: [
          { type: "eRequestName", value: record?.eRequestName },
          { type: "eEmployeeId", value: record?.eEmployeeId },
          {
            type: "eWorkPlaceTeam",
            value: StringHelper.verticalBarSplit<string[]>(record?.eTeam)[1],
          },
          {
            type: "eWorkPlaceDepartment",
            value: [
              StringHelper.verticalBarSplit<string[]>(record?.eUnit)[1],
              StringHelper.verticalBarSplit<string[]>(record?.eDepartment)[1],
            ],
          },
          {
            type: "",
            value:
              "Nay tôi đơn này kính đề nghị Ông Tổng Giám đốc, Trưởng phòng đồng ý giải quyết cho tôi được nghỉ ốm (nuôi con ốm) với thời gian như sau",
          },

          { type: "eVacationPeriod", value: record?.eVacationPeriod },
          {
            type: "eExpectedReturnDate",
            value: record?.eExpectedReturnDate,
          },
          { type: "eReason", value: record?.eReason },
          {
            type: "",
            value:
              "Rất mong nhận được sự chấp thuận của Ông Tổng Giám đốc, Trưởng phòng, Đội trưởng.",
          },
          { type: "", value: "Xin trân trọng cảm ơn." },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: ["TRƯỞNG PHÒNG TCNL", record?.eApprovalProcess[3][0].name],
          },
          {
            type: "signature1",
            value: ["THỦ TRƯỞNG ĐƠN VỊ", record?.eApprovalProcess[1][0].name],
          },
          {
            type: "signature1",
            value: ["NGƯỜI LÀM ĐƠN", record?.eRequestName],
          },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "recipients",
            value: ["- Như trên;", "- Lưu TCNL."],
          },
          {
            type: "signature1",
            value: [
              "PHÊ DUYỆT CỦA TỔNG GIÁM ĐỐC",
              record?.eApprovalProcess[4][0].name,
            ],
          },
        ],
        textBreak: 3,
      },
    ],
  };
};
